import { render } from "./Loyalty.vue?vue&type=template&id=4fa1d206&scoped=true"
import script from "./Loyalty.vue?vue&type=script&lang=js"
export * from "./Loyalty.vue?vue&type=script&lang=js"

import "./Loyalty.vue?vue&type=style&index=0&id=4fa1d206&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa1d206"]])

export default __exports__